<div class="main no-padding">
  <header-menu></header-menu>

  <div class="content" style="position: relative; z-index: 1">
    <div class="content-wrapper establishment-detail-wrapper">
      <div class="col-md-8 col-sm-12 left-column">
        <div class="establishment-cover" *ngIf="establishment?.image?.cover">
          <figure class="image-container">
            <img
              src="{{ imageSrcCover }}"
              onerror="this.parentNode.remove()"
              alt="Allya"
            />
          </figure>
        </div>

        <div id="establishment-detail" class="card">
          <div class="card-content">
            <header>
              <div
                class="establishment-detail-photo"
                *ngIf="establishment?.image?.logo"
              >
                <img src="{{ imageSrcLogo }}" alt="Allya logo" />
              </div>
              <div class="establishment-detail-info">
                <div
                  class="partnership-badge-row"
                  *ngIf="getPartnershipBadge()"
                >
                  <div class="premium-partner-badge">
                    <img
                      [src]="getPartnershipBadgeIcon()"
                      [alt]="getPartnershipBadgeLabel()"
                      class="premium-icon"
                    />
                    <span class="premium-text">{{ getPartnershipBadgeLabel() }}</span>
                  </div>
                  <button
                    *ngIf="getPartnershipBadge() === 'exclusive'"
                    type="button"
                    class="exclusive-info-tooltip"
                    [class.is-open]="exclusiveTooltipOpen"
                    aria-label="Informações sobre parcerias exclusivas"
                    (click)="toggleExclusiveTooltip($event)"
                  >
                    <img src="assets/shared/img/tooltip-icon.svg" alt="" />
                    <span class="exclusive-tooltip-bubble">
                      As <strong>Parcerias Exclusivas</strong> oferecem benefícios especiais para quem faz parte da empresa
                      <strong>{{ getCompanyName() }}</strong>.
                    </span>
                  </button>
                </div>
                <h2>{{ establishment?.name }}</h2>
                <p>
                  <span *ngIf="establishment?.addresses?.length === 1">
                    <strong
                      >{{ "DETAIL.ESTABLISHMENT.ADDRESS" | translate }}:</strong
                    >
                    {{ getAddressAsString(establishment?.addresses[0]) }}
                    <br />
                    <span
                      *ngIf="
                        establishment?.addresses[0].phone ||
                        establishment?.offer.contact.phone
                      "
                    >
                      <strong
                        >{{
                          "DETAIL.ESTABLISHMENT.PHONE_NUMBER_LABEL" | translate
                        }}:</strong
                      >
                      {{
                        establishment?.addresses[0].phone
                          ? establishment?.addresses[0].phone
                          : establishment?.offer.contact.phone
                      }}
                      <br />
                    </span>
                  </span>
                </p>
              </div>
            </header>
            <div class="establishment-detail-actions">
              <div>
                <span
                  *ngIf="
                    (getUserLevel() === 'master' ||
                      getUserLevel() === 'finance') &&
                    !establishment?.is_own_partnership
                  "
                >
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="content-wrapper establishment-detail-wrapper">
          <div class="col-md-12 col-sm-12 left-column">
            <div id="establishment-detail" class="card">
              <div class="establishment-actions-bar">
                <a (click)="openReportIrregularityModal()">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  {{ "DETAIL.ESTABLISHMENT.INFORM_ERROR_BUTTON" | translate }}
                </a>
                <a (click)="toggleFavorite()">
                  <i
                    class="fa"
                    [ngClass]="isFavorite ? 'fa-heart' : 'fa-heart-o'"
                    aria-hidden="true"
                  ></i>
                  {{ "DETAIL.ESTABLISHMENT.FAVORITE_BUTTON" | translate }}
                </a>
                <a *ngIf="!showShareButtons" (click)="toggleShowShareButtons()">
                  <i class="fa fa-share-alt" aria-hidden="true"></i>
                  {{ "DETAIL.ESTABLISHMENT.SHARE_BUTTON" | translate }}
                </a>
                <div class="buttons-share-area" *ngIf="showShareButtons">
                  <button
                    [sbDescription]="offerTitleEncoded"
                    [sbTitle]="establishment?.name"
                    [sbImage]="establishment?.image?.logo"
                    class="btn btn-share btn-twitter"
                    shareButton="twitter"
                  >
                    <i class="fa fa-twitter"></i>
                  </button>
                  <button
                    [sbDescription]="establishment?.offer?.title"
                    [sbTitle]="establishment?.name"
                    [sbImage]="establishment?.image?.logo"
                    class="btn btn-share btn-whatsapp"
                    shareButton="whatsapp"
                  >
                    <i class="fa fa-whatsapp"></i>
                  </button>
                  <button
                    [sbDescription]="establishment?.offer?.title"
                    [sbTitle]="establishment?.name"
                    [sbImage]="establishment?.image?.logo"
                    class="btn btn-share btn-facebook"
                    shareButton="facebook"
                  >
                    <i class="fa fa-facebook"></i>
                  </button>
                </div>
              </div>

              <div class="card-content card-carousel" *ngIf="imageSrcGallery">
                <div class="establishment-carousel">
                  <div class="carousel-container">
                    <div
                      class="carousel-item"
                      *ngFor="let image of imageSrcGallery; let i = index"
                      (click)="openImage(i)"
                    >
                      <div
                        class="carousel-content"
                        [ngStyle]="{ 'background-image': 'url(' + image + ')' }"
                      >
                        <span class="fa fa-search"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-content card-about" *ngIf="establishment?.about">
                <div class="establishment-detail-description">
                  <p [innerHTML]="establishment?.about | safeHtml"></p>
                </div>
              </div>
            </div>

            <h3 *ngIf="addresses?.length">
              {{ "DETAIL.ESTABLISHMENT.LOCATIONS" | translate }}
            </h3>

            <div
              id="establishment-detail-location"
              class="card"
              *ngIf="addresses?.length"
            >
              <div
                *ngIf="canDisplayMap()"
                style="height: 400px; width: 100%"
                leaflet
                [leafletOptions]="options"
                [leafletLayers]="markers"
              ></div>
              <div
                *ngIf="!canDisplayMap() && referenceAddress"
                id="establishment-detail-location-map"
                style="
                  background: #fff
                    url(../../../assets/shared/img/banners/map.png) no-repeat;
                  background-size: 105%;
                "
              >
                <div class="pop-up" *ngIf="addresses?.length > 0">
                  <strong>{{ referenceAddress?.nameUnit }}</strong>
                  {{ referenceAddress?.street }}, {{ referenceAddress?.number }}
                  <button (click)="displayMap()" class="btn-orange-contrast">
                    {{ "DETAIL.ESTABLISHMENT.SEE_ON_MAP_BUTTON" | translate }}
                  </button>
                </div>
              </div>
              <button class="btn" (click)="displayAllAddresses()">
                {{
                  displayAllAddressesFlag
                    ? "- Esconder todas as unidades"
                    : "+ Mostrar todas as unidades"
                }}
              </button>
            </div>

            <ul class="card" *ngIf="canDisplayAllAddresses()">
              <li>
                <input
                  #inputAddress
                  [(ngModel)]="addressFilter"
                  class="address-filter-input"
                  placeholder="Pesquisar"
                  type="text"
                  (input)="filterAddress(inputAddress.value)"
                />
              </li>
              <li *ngFor="let address of filteredAddresses">
                <strong>{{ address?.nameUnit }}</strong>
                <br />
                {{ address?.street }}, {{ address?.number }},
                {{ address?.neighborhood }} - {{ address?.county }}/{{
                  address?.state
                }}
                <br />CEP: {{ address?.cep || "-" }} <br />Contato:
                {{ address?.phone || "-" }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12 right-column">
        <ng-promo-establishment
          [establishmentId]="establishment?.id"
        ></ng-promo-establishment>

        <div *ngIf="establishment != null">
          <h3>Ofertas</h3>

          <!-- Bloqueio para usuários FREE em parceiros PREMIUM -->
          <div *ngIf="shouldBlockOffers()" class="promotion card card-pink">
            <div class="card-content">
              <header>
                <h2>{{ establishment?.offer?.title }}</h2>
              </header>
              <div class="premium-block-overlay">
                <div class="premium-block-content">
                  <div class="premium-block-icon">
                    <img
                      src="assets/shared/img/partners/iconografia-fremium.svg"
                      alt="Premium"
                    />
                  </div>
                  <h3>Desbloqueie mais vantagens!</h3>
                  <p>
                    Este parceiro é exclusivo para assinantes premium da Allya.
                    Mas não se preocupe! Atualize seu plano agora e aproveite
                    descontos ainda melhores, ofertas especiais e benefícios
                    exclusivos.
                  </p>
                  <button
                    class="btn btn-premium"
                    (click)="goToPremiumCheckout()"
                  >
                    Assinar o premium
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Ofertas normais para usuários premium ou parceiros não-premium -->
          <div *ngIf="!shouldBlockOffers()" class="promotion card card-pink">
            <div class="card-content">
              <header>
                <h2>{{ establishment?.offer?.title }}</h2>
              </header>
              <div
                class="counter"
                *ngIf="showCounter(establishment.offer.expires_at)"
              >
                <img src="assets/shared/img/clock.png" alt="Allya logo" />
                <div class="expire">
                  <p class="ofert">Oferta expira em:</p>
                  <p class="date">
                    {{ establishment.offer.expires_at | date : "dd/MM/yyyy" }}
                  </p>
                </div>
                <div
                  class="hours"
                  *ngIf="verifyDate(establishment.offer.expires_at)"
                >
                  <p class="numbers">
                    {{
                      resolveDateToTime(establishment.offer.expires_at).hours
                    }}
                    :
                    {{
                      resolveDateToTime(establishment.offer.expires_at).minutes
                    }}
                  </p>
                  <div class="description">
                    <p>Horas</p>
                    <p>Min</p>
                  </div>
                </div>
                <div
                  class="hours"
                  *ngIf="!verifyDate(establishment.offer.expires_at)"
                >
                  <p class="numbers">
                    {{ resolveDateToTime(establishment.offer.expires_at).days }}
                    :
                    {{
                      resolveDateToTime(establishment.offer.expires_at).hours
                    }}
                  </p>
                  <div class="description">
                    <p>Dias</p>
                    <p>Horas</p>
                  </div>
                </div>
              </div>
              <div class="description">
                <!-- @TODO: escape this html to remove script tags -->
                <p [innerHTML]="establishment?.offer?.term | safeHtml"></p>
              </div>

              <!-- 99Abastece - Confirmação de celular e resgate do benefício -->
              <ng-nove-nove-checkout
                *ngIf="is99AbastecesGroup()"
                [establishment]="establishment"
                (generateCouponClick)="trackingEventButton('gerar-cupom')"
                (activateBenefitClick)="trackingEventButton('ativar-beneficio')"
                (desktopBenefitClick)="trackingEventButton('gerar-cupom-desktop')"
              ></ng-nove-nove-checkout>

              <!-- Group Standard, Group Standard With App and Group Standard With Whatsapp-->
              <footer
                class="text-center"
                *ngIf="!is99AbastecesGroup() && verifyEstablishmentType('gerar-cupom')"
              >
                <button
                  class="btn cupom-button"
                  (click)="generateCoupon('gerar-cupom')"
                >
                  {{
                    "DETAIL.ESTABLISHMENT.GENERATE_COUPON_BUTTON" | translate
                  }}
                </button>
              </footer>

              <!-- Group Online -->
              <footer
                class="text-center"
                *ngIf="!is99AbastecesGroup() && verifyEstablishmentType('ir-para-o-site')"
              >
                <button
                  class="btn cupom-button"
                  (click)="generateCoupon('ir-para-o-site')"
                >
                  {{ "DETAIL.ESTABLISHMENT.GO_TO_PARTNER_WEBSITE" | translate }}
                </button>
              </footer>

              <!-- Group Online With Coupon-->
              <footer
                class="text-center"
                *ngIf="!is99AbastecesGroup() && verifyEstablishmentType('ir-para-o-site-com-cupom')"
              >
                <button
                  class="btn cupom-button"
                  (click)="generateCoupon('ir-para-o-site-com-cupom')"
                >
                  {{
                    "DETAIL.ESTABLISHMENT.GENERATE_COUPON_BUTTON" | translate
                  }}
                </button>
              </footer>

              <!-- Group Cinemark -->
              <footer
                class="text-center"
                *ngIf="!is99AbastecesGroup() && verifyEstablishmentType('cinemark-primepass')"
              >
                <ng-tickets-modal
                  (click)="
                    oldTrackingEvent(establishment.name, 'comprar-ingresso')
                  "
                  [establishment]="establishment"
                  [title]="'DETAIL.ESTABLISHMENT.CART_TICKETS' | translate"
                >
                </ng-tickets-modal>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<modal
  #modalInvite
  [backdrop]="false"
  [backgroundImage]="backgroundImageUrl"
  [showBackground]="true"
>
  <modal-content>
    <modal-coupon [modalData]="couponModalData"></modal-coupon>
  </modal-content>
</modal>

<modal
  #modalReportIrregularity
  [backdrop]="true"
  modalClass="report-irregularity-dialog"
>
  <modal-header>
    <h4 class="report-irregularity-title">Informar irregularidade</h4>
  </modal-header>
  <modal-content>
    <div class="report-irregularity-form">
      <label for="irregularity-description">Descrição da irregularidade</label>
      <textarea
        id="irregularity-description"
        name="irregularityDescription"
        rows="5"
        placeholder="Descreva o problema ocorrido neste estabelecimento, e se possível, o nome da pessoa que te atendeu."
        [(ngModel)]="irregularityDescription"
      ></textarea>
      <div class="report-irregularity-actions">
        <button
          type="button"
          class="btn-irregularity-cancel"
          (click)="modalReportIrregularity.close()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-irregularity-submit"
          [disabled]="!irregularityDescription.trim() || irregularitySubmitting"
          (click)="submitReportIrregularity()"
        >
          <i *ngIf="irregularitySubmitting" class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
          <span *ngIf="!irregularitySubmitting">Enviar</span>
        </button>
      </div>
    </div>
  </modal-content>
</modal>

<platform-access-blocked-modal></platform-access-blocked-modal>

<div *ngIf="isLoading" class="logo-gif">
  <img src="assets/shared/img/logo_allya.gif" alt="Allya logo" />
</div>
